export const cognito = {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_BpvsEDWMS",
    APP_CLIENT_ID: "1hljt6v5lp22usppp84lslfv42"
};
